/**
 * Mock Aruba groups — mix of compliant + drifted, varied AOS versions.
 */
import type { ArubaGroup } from "@/api/schemas/aruba";

export const MOCK_ARUBA_GROUPS: ArubaGroup[] = [
  { name: "PAR-09 IDF",   architecture: "Switch",   aosVersion: "AOS-CX 10.13.1010", allowedDevices: ["SW"],          deviceCount: 6, compliant: true  },
  { name: "PAR-09 Floors",architecture: "Wireless", aosVersion: "AOS-10 10.5.1.0",   allowedDevices: ["AP"],          deviceCount: 24,compliant: true  },
  { name: "MIA-12 IDF",   architecture: "Switch",   aosVersion: "AOS-CX 10.13.1005", allowedDevices: ["SW"],          deviceCount: 4, compliant: false },
  { name: "MIA-12 Floors",architecture: "Wireless", aosVersion: "AOS-10 10.5.0.5",   allowedDevices: ["AP"],          deviceCount: 18,compliant: false },
  { name: "SEA-15 Mixed", architecture: "Mixed",    aosVersion: "AOS-CX 10.13.1010", allowedDevices: ["SW","AP"],     deviceCount: 22,compliant: true  },
];
